"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _reselect = require("reselect");

var _GoodFiltersAndPage = _interopRequireDefault(require("../constants/GoodFiltersAndPage"));

var _IndustryOptions = _interopRequireDefault(require("../constants/IndustryOptions"));

var _react = _interopRequireWildcard(require("react"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _UIDropdown = _interopRequireDefault(require("UIComponents/dropdown/UIDropdown"));

var _UITypeahead = _interopRequireDefault(require("UIComponents/typeahead/UITypeahead"));

var _utils = require("../utils/utils");

var _langUtils = require("../utils/langUtils");

var getIndustries = (0, _reselect.createSelector)([function () {
  return _IndustryOptions.default;
}], function (industryOptions) {
  var __ALL = industryOptions.ALL,
      __OTHER_INDUSTRY = industryOptions.OTHER_INDUSTRY,
      industries = (0, _objectWithoutProperties2.default)(industryOptions, ["ALL", "OTHER_INDUSTRY"]);
  return (0, _utils.getAlphaSortedArrOfTextValPairsForSelect)(Object.keys(industries), _langUtils.getIndustryOptionText, _IndustryOptions.default.ALL);
});

var _default = _react.default.createClass({
  displayName: "IndustryDropdown",
  mixins: [_reactAddonsPureRenderMixin.default],
  propTypes: {
    onGoodFilterChange: _react.PropTypes.func.isRequired,
    industryFilter: _react.PropTypes.string.isRequired
  },
  handleIndustryUpdate: function handleIndustryUpdate(event) {
    var params = {};
    params[_GoodFiltersAndPage.default.INDUSTRY] = event.target.value;
    return this.props.onGoodFilterChange(params);
  },
  render: function render() {
    var industryFilter = this.props.industryFilter;
    return _react.default.createElement("div", null, _react.default.createElement("div", {
      className: "is--heading-7 m-bottom-1"
    }, (0, _langUtils.getIndustryOptionText)('title')), _react.default.createElement(_UIDropdown.default, {
      buttonClassName: "integrate-industry-dropdown p-all-0",
      buttonText: (0, _langUtils.getIndustryOptionText)(industryFilter),
      buttonUse: "transparent",
      placement: "bottom right"
    }, _react.default.createElement(_UITypeahead.default, {
      onChange: this.handleIndustryUpdate,
      options: getIndustries(),
      value: industryFilter
    })));
  }
});

exports.default = _default;
module.exports = exports.default;